import React, {Fragment} from 'react';
import {Dropdown, Form, Input} from 'semantic-ui-react';
import includes from 'lodash/includes';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import {ROLES, RoleList} from '../../constants';

const UserForm = ({customerOptions, user, role, handleTextChanged}) => {
  const shouldRenderCompanyInput = includes([ROLES.SEARCH_ONLY], user.role);
  const shouldRenderCustomerSelector =
    (role === ROLES.SYSTEM_ADMIN || role === ROLES.MM_ADMIN) &&
    includes([ROLES.CUSTOMER_ADMIN, ROLES.CUSTOMER_USER], user.role);
  const userIsSearchOnly = includes([ROLES.SEARCH_ONLY], user.role);
  const roleOptions = RoleList.filter(x => {
    if (role === ROLES.SYSTEM_ADMIN) return true;
    else if (role === ROLES.MM_ADMIN && x !== ROLES.SYSTEM_ADMIN) return true;
    else return x !== ROLES.MM_ADMIN && x !== ROLES.SYSTEM_ADMIN;
  }).map(x => ({text: x, value: x}));

  return (
    <Fragment>
      <Form.Group widths="equal">
        <Form.Field
          id="form-create-firstName"
          name="firstName"
          value={user.firstName}
          onChange={handleTextChanged}
          control={Input}
          label="First Name"
        />
        <Form.Field
          id="form-create-lastName"
          name="lastName"
          value={user.lastName}
          onChange={handleTextChanged}
          control={Input}
          label="Last Name"
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Field
          id="form-create-emailAddress"
          name="emailAddress"
          value={user.emailAddress}
          onChange={handleTextChanged}
          label="Email Address"
          control={Input}
        />
        <Form.Field
          id="form-create-phoneNumber"
          name="phoneNumber"
          value={user.phoneNumber}
          onChange={value =>
            handleTextChanged(null, {name: 'phoneNumber', value: value})
          }
          label="Phone Number"
          control={PhoneInput}
          inputStyle={{paddingLeft: 50, height: 40}}
          country={'us'}
          preferredCountries={['us']}
          disableAreaCodes
        />
      </Form.Group>

      <Form.Field
        id="form-create-role"
        name="role"
        value={user.role}
        onChange={handleTextChanged}
        label="Role"
        selection
        control={Dropdown}
        options={roleOptions}
      />

      <Form.Group widths="equal">
        {shouldRenderCustomerSelector && (
          <Form.Field
            id="form-create-customer"
            name="customerId"
            value={user.customerId}
            onChange={handleTextChanged}
            label="Customer"
            selection
            control={Dropdown}
            options={customerOptions}
          />
        )}

        {shouldRenderCompanyInput && userIsSearchOnly && (
          <Form.Field
            id="form-create-company"
            name="company"
            value={user.company}
            onChange={handleTextChanged}
            label="Company"
            control={Input}
          />
        )}

        <Form.Field
          id="form-create-title"
          name="title"
          value={user.title}
          onChange={handleTextChanged}
          control={Input}
          label="Title"
        />
      </Form.Group>
    </Fragment>
  );
};

export default UserForm;
